import {SET_YOUTUBE_SEARCH_TERMS} from 'constants/action-types.js';
import {SET_SELECTED_RECORD} from 'constants/action-types.js';

let initialState = {
    youtubeSearchTerms: '',
    selectedRecord: undefined,
};

const discoverReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_YOUTUBE_SEARCH_TERMS:
        return {
            ... state,
            youtubeSearchTerms: action.payload
        };
    case SET_SELECTED_RECORD:
        return {
            ... state,
            selectedRecord: action.payload
        };
    default:
        return state;
    }
}

export default discoverReducer;
